module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Kadu_Larissa.b97c8979.jpg";